import { render } from "./MapTabs.vue?vue&type=template&id=b581a8be&scoped=true"
import script from "./MapTabs.vue?vue&type=script&lang=js"
export * from "./MapTabs.vue?vue&type=script&lang=js"

import "./MapTabs.vue?vue&type=style&index=0&id=b581a8be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b581a8be"]])

export default __exports__